document.addEventListener('DOMContentLoaded', () => {
  // ── Top-level tab switching ──
  const tabLinks = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      tabLinks.forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      });

      tabPanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      link.classList.add('is-active');
      link.setAttribute('aria-selected', 'true');

      const targetID = link.dataset.tabTarget;
      const targetPanel = document.getElementById(targetID);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        targetPanel.setAttribute('aria-hidden', 'false');
      }
    });
  });

  // ── Second-level subtab switching ──
  tabPanels.forEach((panel) => {
    const subtabButtons = panel.querySelectorAll('.subtab-button');
    const subtabPanels = panel.querySelectorAll('.subtab-panel');

    subtabButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();

        // Deactivate all subtabs in this panel
        subtabButtons.forEach((b) => {
          b.classList.remove('is-active');
          b.querySelector('.submenu-arrow').textContent = '';
        });
        subtabPanels.forEach((p) => {
          p.classList.remove('is-active');
        });

        // Activate clicked subtab
        btn.classList.add('is-active');
        btn.querySelector('.submenu-arrow').textContent = '\u2192';

        // Show matching sub-panel
        const targetID = btn.dataset.subtabTarget;
        const targetSubPanel = document.getElementById(targetID);
        if (targetSubPanel) {
          targetSubPanel.classList.add('is-active');
        }
      });
    });
  });
});
